import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SECURITY_DEPOSIT, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the security deposit as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemSecurityDepositMaybe = props => {
  const { lineItems, intl } = props;

  const securityDepositLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SECURITY_DEPOSIT && !item.reversal
  );

  return securityDepositLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.securityDeposit" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, securityDepositLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemSecurityDepositMaybe;
